/**
 * Vida consagrada y comunidades religiosas - Diócesis de Ipiales.
 * Confrontado con documento oficial: Sacerdotes congregantes, Orden Capuchinos,
 * Misioneros Scalabrinianos, Oblatos, Comunidades Religiosas.
 */

/** Sacerdotes Congregantes del Oratorio de San Felipe Neri - Ipiales */
export const oratorioSanFelipeNeri = [
  { nombre: 'R.P. Hermes Jesús Mejía Mejía', email: 'hermesjesus_2015@hotmail.com', celular: '317 508 0563' },
  { nombre: 'R.P. Evin Aroldy López Romero', email: 'aroldylopez@hotmail.com', celular: '311 643 4684' },
  { nombre: 'R.P. Francisco Alberto Narváez Cabrera', email: 'alfranciscof@hotmail.com', celular: '317 705 9016' },
  { nombre: 'R.P. Jorge Ricardo Escobar Portilla', email: 'ejorgericardo@hotmail.com', celular: '318 378 8897' },
  { nombre: 'R.P. Isnardo Serrano Rodríguez', email: 'isnardoserrano@yahoo.com', celular: '321 241 9453' },
  { nombre: 'R.P. Edgar José Juez Gonzalez', email: 'edjuez@gmail.com', celular: '313 482 6672' },
  { nombre: 'R.P. Edgar Sebastián Sarchi Chingual', email: 'Esarchi2014@gmail.com', celular: '316 850 0497' },
];

/** Orden de Hermanos Menores Capuchinos */
export const capuchinos = {
  despacho: '7280249',
  religiosos: [
    { nombre: 'Fray Alirio Maximiliano Rojas Ortiz, OFM Cap', email: 'frayalirio@yahoo.es', celular: '314 295 4691' },
    { nombre: 'Fray José Julián Giraldo Trujillo', email: 'frajjgt@gmail.com', celular: '+39 348 088 1736' },
    { nombre: 'Fray Dubián Aliro Gómez López, OFM Cap', email: 'dubianaliriog@gmail.com', celular: '321 371 4817' },
  ],
};

/** Misioneros de San Carlos – Scalabrinianos. Hogar de Paso Buen Samaritano */
export const scalabrinianos = {
  email: 'scalabriniciamipiales@gmail.com',
  religiosos: [
    { nombre: 'Jean Carlos Uribe Camperos', celular: '313 806 7170' },
    { nombre: 'Yohanes Lapans', celular: '310 533 9710' },
  ],
};

/** Congregación de Misioneros Oblatos de los Corazones Santísimos */
export const oblatosCorazonesSantísimos = [
  { nombre: 'P. Sergio Ramiro Pinchao Cuaran, cc.ss.', celular: '315 419 0507', email: 'sergiocuaran5@gmail.com' },
];

/** Comunidades religiosas: nombre, superiora, celular, lugar de servicio */
export const comunidadesReligiosas = [
  { comunidad: 'Hnas. Franciscanas de María Inmaculada (Colegio San Francisco de Asís)', superiora: 'Hna. Amparo Pastas', celular: '315 417 0441', lugar: 'Ipiales' },
  { comunidad: 'Hnas. Oblatas de los Corazones Santísimos de Jesús y María', superiora: 'Hna. Bertha Lucía Félix Ruiz', celular: '321 689 4057', lugar: 'Ipiales' },
  { comunidad: 'Congregación de Dominicas de Santa Catalina de Siena', superiora: 'Sor. Fanny Hoyos / Sor Karina Narvaez', celular: '310 630 2072', lugar: 'Ipiales' },
  { comunidad: 'Hnas. Domínicas de Nazareth', superiora: 'Hna. Gloría Isabel Huérfano Pérez', celular: '321 370 1685', lugar: 'B/Pinares de Santa Ana – Ipiales' },
  { comunidad: 'Hermanitas de los Ancianos Desamparados', superiora: 'Hna. María Ignacia Romero Rincón', celular: '315 418 2782', lugar: 'Ipiales' },
  { comunidad: 'Monasterio del Sagrado Corazón de Jesús - Hnas. Concepcionistas', superiora: 'Hna. María Edith Mora Apráez', celular: '314 680 0691', lugar: 'Ipiales' },
  { comunidad: 'Instituto de Religiosas Filipenses Hijas de María Dolorosa', superiora: 'Hna. Julia María Rayo Candelo', celular: '317 831 9470', lugar: 'Ipiales' },
  { comunidad: 'Hnas. Franciscanas de María Inmaculada (Colegio Ntra. Sra. de Las Lajas)', superiora: 'Hna. Claudia Coral Reina', celular: '317 067 9363', lugar: 'Ipiales' },
  { comunidad: 'Hnas. Franciscanas de María Inmaculada', superiora: 'Hna. Melba Margarita Mueses', celular: '311 625 6139', lugar: 'Potosí' },
  { comunidad: 'Hnas. Oblatas de los Corazones Santísimos de Jesús y María', superiora: 'Hna. Guadalupe Ramírez Luna', celular: '315 014 2301', lugar: 'Iles' },
  { comunidad: 'Hermanitas de la Anunciación', superiora: 'Hna. Bárbara Albarracín', celular: '314 695 6432', lugar: 'Carlosama' },
  { comunidad: 'Hnas. de Santa Marianita de Jesús', superiora: 'Hna. Yenny Piedra', celular: '311 747 2115', lugar: 'Cumbal' },
  { comunidad: 'Misioneras Madre Laura', superiora: 'Hna. Julia Velasco Trujillo', celular: '321 845 1897', lugar: 'Ricaurte' },
  { comunidad: 'Hnas. Misioneras de la Inmaculada Concepción', superiora: 'Hna. Gloria Stella Moreno', celular: '313 396 7000', lugar: 'Samaniego' },
  { comunidad: 'Religiosas Franciscanas de María Inmaculada', superiora: 'Hna. Nilda María Medina', celular: '321 817 5590', lugar: 'Samaniego' },
  { comunidad: 'Hnas. Dominicas de Betania', superiora: 'Hna. Mariela Quiroga', celular: '311 589 0521', lugar: 'Las Lajas' },
  { comunidad: 'Religiosas Oblatas de los Corazones Santísimos de Jesús y María', superiora: 'Hna. Blanca Toalongo', celular: '322 561 7885', lugar: 'Puerres' },
  { comunidad: 'Siervas de la Iglesia', superiora: 'Hna. Ana Brígida López Carvajal', celular: '302 540 7097', lugar: 'Ipiales' },
];
